import React, {useEffect, useState} from "react";
import {useHistory} from 'react-router-dom';
import DataTable from "../../_components/DataTable";
import {useDispatch, useSelector} from "react-redux";
import {alertActions, regionsActions, surfaceActions} from "../../_actions";
import FloatingActionButton from "../../_components/FloatingActionButton";
import ConfirmationModal from "../../Common/ConfirmationModal";


const RegionList = () => {
    const regions = useSelector((state) => state.regions);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [selectedRegionId, setSelectedRegionId] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        refresh();
    }, []);

    function refresh() {
        dispatch(regionsActions.getList());
        dispatch(surfaceActions.showHeaderSearchBar(true));
        dispatch(surfaceActions.setPageTitle("Region List"));
        dispatch(alertActions.clear());
        dispatch(surfaceActions.setSearchFunc(search));
    }

    const search = (value) => {
        dispatch(regionsActions.getList(value));
    }

    /**Functions for action menus **/

    const editRegion = (closeHandler, regionId) => {
        closeHandler();
        history.push(`/admin/region/update/${regionId}`);
    }

    const deleteRegion = (closeHandler, regionId) => {
        closeHandler();
        setConfirmationModalOpen(true);
        setSelectedRegionId(regionId);

    }

    const confirmationModalCloseHandler = (event, proceedAction) => {
        setConfirmationModalOpen(false);
        if (proceedAction) {
            dispatch(regionsActions.deleteRegion(selectedRegionId));
            setSelectedRegionId(null);
        }
    }


    const columns = [
        {
            header: "Region",
            field: "Name",
        },
        {
            header: "Client",
            field: "Client.Name",
        },
        {
            header: "Description",
            field: "Description",
        },
        {
            header: "Actions",
            field: "sk",
            disableSorting: true,
            actions: [
                {clickListener: editRegion, label: 'Edit'},
                {clickListener: deleteRegion, label: 'Delete'}
            ]
        },
    ];

    return (
        <div>
            {
                regions ?
                    <DataTable dataCollection={regions} columns={columns}></DataTable>
                    : null
            }

            <FloatingActionButton path={'/admin/region/new'}/>
            <ConfirmationModal open={confirmationModalOpen} closeHandler={confirmationModalCloseHandler}/>
        </div>
    );
}

export default RegionList;
